import { Vector2 } from "api/types/sketch";
import { Text } from "api/types/sketch";
import { clockwise } from "functions/sketch/math";
import { getAngle } from "functions/sketch/math";
import { getDistantPoint } from "functions/sketch/math";
import { COUNTER_LABEL } from "values/text";

export function counterLabelText(
  previous_vertex: Vector2,
  vertex: Vector2,
  next_vertex: Vector2,
  match_label: string,
  match_id: number | string
): Text {
  const angle: number = getAngle(previous_vertex, vertex);
  const next_angle: number = getAngle(vertex, next_vertex);
  let text_location: Vector2 = getDistantPoint(vertex, angle, 10);
  text_location = getDistantPoint(text_location, next_angle, 10);

  return {
    location: text_location,
    value: 0,
    real_value: 0,
    text: `${match_label}${match_id}`,
    corner_uuid: "",
    counter_uuid: "",
    point_uuid: "",
    type: COUNTER_LABEL,
    angle: angle,
    mirror: clockwise(angle, next_angle)
  };
}
